/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/

export const momentShortFormat = {
  relativeTime : {
      future: "in %s",
      past:   "%s ago",
      s  : '< 1 min',
      ss : '%d secs',
      m:  "1 min",
      mm: "%d mins",
      h:  "1 hr",
      hh: "%d hrs",
      d:  "1 day",
      dd: "%d days",
      M:  "a mo",
      MM: "%d mos",
      y:  "a yr",
      yy: "%d yrs"
  }
}

export const DATE_FORMAT_CONCISE = 'M/D/YY';

export const SYNC_BACKOFF = 300_000; // five minute sync delay
export const FIVE_MINUTES = SYNC_BACKOFF;
export const TEN_MINUTES = 600_000;
